<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="From"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Activity Type" >
                                        <select class="form-control" v-model="inputTrans">
                                            <option v-for="option in transOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'terminal_id',
                groupOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'session_id', value: 'Session'}
                ],
                inputTrans: 'ADD',
                transOptions: [
                    {key: 'ADD', value: 'Add Item'},
                    {key: 'ATL', value: 'At The Moment'},
                    {key: 'CUS', value: 'Customer'},
                    {key: 'DEC', value: 'Declarations'},
                    {key: 'DEP', value: 'Deposit'},
                    {key: 'DIS', value: 'Discount'},
                    {key: 'FLT', value: 'Float'},
                    {key: 'IDC', value: 'Item Discount'},
                    {key: 'LVD', value: 'Line Void'},
                    {key: 'OPD', value: 'Open Department'},
                    {key: 'ODIS', value: 'Overall Discount'},
                    {key: 'PAY', value: 'Payment'},
                    {key: 'ACT', value: 'PNSTM Discount'},
                    {key: 'OVR', value: 'Price Override'},
                    {key: 'PWD', value: 'PWD Discount'},
                    {key: 'RES', value: 'Resume'},
                    {key: 'RET', value: 'Return'},
                    {key: 'RPN', value: 'Reprint'},
                    {key: 'RXR', value: 'Reprint X Reading'},
                    {key: 'RZR', value: 'Reprint Z Reading'},
                    {key: 'SAL', value: 'Sales'},
                    {key: 'SCD', value: 'SC Discount'},
                    {key: 'SCN', value: 'Scan Item'},
                    {key: 'SOF', value: 'Sign Off'},
                    {key: 'SON', value: 'Sign On'},
                    {key: 'SUS', value: 'Suspend'},
                    {key: 'SYN', value: 'Sync'},
                    {key: 'TMI', value: 'To Manual Invoice'},
                    {key: 'TVD', value: 'Transaction Void'},
                    {key: 'WIT', value: 'Withdrawal'},
                    {key: 'XRD', value: 'X Reading'},
                    {key: 'ZRD', value: 'Z Reading'}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                reportDescription: ''

            }
        },
        mounted: async function () {
            var component_x = this;
            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            this.reportDescription = await getReportDescription(this.currentProfile)

        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            // Parse a pos_activities.data value into an object.
            // Handles a plain object as well as JSON that has been string-encoded
            // one OR more times. Older rows are double-encoded (a string whose
            // content is JSON); newer rows (e.g. TMI activity on 09/30) arrive
            // triple-encoded because the agent now sends `data` already stringified
            // and the backend re-runs .to_json on it. Unwrap iteratively so any
            // level of nesting resolves to the underlying object.
            parseData(raw) {
                if (raw == null || raw == "null") {
                    return null;
                }
                // If the API already returned a parsed object, use it directly.
                if (typeof raw === 'object') {
                    return raw;
                }
                let current = raw;
                // Peel off each JSON-string layer until we land on an object (or can
                // no longer parse). Cap the iterations to avoid any infinite loop.
                for (let i = 0; i < 10 && typeof current === 'string'; i++) {
                    let parsed;
                    try {
                        parsed = JSON.parse(current);
                    } catch (e) {
                        // Not parseable as JSON: can't resolve to an object.
                        return null;
                    }
                    current = parsed;
                }
                return (current && typeof current === 'object') ? current : null;
            },
            // Convert a data key into a human-friendly column header.
            // camelCase and snake_case are both split into Title Case words, e.g.
            //   transactionNumber -> Transaction Number
            //   lineNo            -> Line No
            //   discountPercent   -> Discount Percent
            //   discount_amount1  -> Discount Amount1
            formatHeader(key) {
                if (key === null || key === undefined) {
                    return '';
                }
                let str = key.toString();
                // Leave purely numeric keys (e.g. '0', '1') untouched.
                if (/^\d+$/.test(str)) {
                    return str;
                }
                return str
                    // split camelCase / PascalCase boundaries: aB -> a B
                    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
                    // split acronym boundaries: ABCd -> AB Cd
                    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
                    // underscores and hyphens become spaces
                    .replace(/[_-]+/g, ' ')
                    // collapse extra whitespace
                    .replace(/\s+/g, ' ')
                    .trim()
                    // Title Case each word (keep trailing digits attached, e.g. Amount1)
                    .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            },
            // Collect the union of data keys across all report rows, in first-seen order,
            // so no key/value pair (e.g. discountReason) is lost when rows differ in shape.
            collectDataKeys(reportRows) {
                let keys = [];
                let seen = {};
                for (let r = 0; r < reportRows.length; r++) {
                    let obj = this.parseData(reportRows[r].data);
                    if (obj == null) {
                        continue;
                    }
                    for (let key of Object.keys(obj)) {
                        if (!seen[key]) {
                            seen[key] = true;
                            keys.push(key);
                        }
                    }
                }
                return keys;
            },
            // Collect the union of data keys across EVERY row of EVERY site, so the report
            // uses one consistent set of data columns even when rows have different shapes
            // (e.g. 2 keys, then 4 keys, then 3 keys) and span multiple sites.
            collectAllDataKeys(siteSpecific) {
                let allRows = [];
                for (let x = 0; x < siteSpecific.length; x++) {
                    let details = siteSpecific[x].report_details || [];
                    for (let r = 0; r < details.length; r++) {
                        allRows.push(details[r]);
                    }
                }
                return this.collectDataKeys(allRows);
            },
            generateReport: async function () {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_activity_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&group=' + this.inputGroupBy + '&trans_code=' + this.inputTrans, null);
                let reportLogo = document.getElementById('reportLogo');

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let field_count = 4
                    if(this.inputGroupBy == 'session_id'){
                        field_count = 3
                    }

                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    // Union of data keys across EVERY row of EVERY site. Used for both the
                    // page-size calculation and the actual columns, so the widest row (e.g.
                    // an IDC with 4 keys) dictates the column set for the whole report.
                    let allDataKeys = this.collectAllDataKeys(siteSpecific)
                    field_count = field_count + allDataKeys.length

                    // Choose a page format wide enough for the total column count.
                    // remaining_width is kept at 0 so no single column is over-inflated;
                    // instead every data column gets a fixed, page-friendly width below.
                    if(field_count <= 10){
                        // default legal landscape is fine
                    } else if(field_count <= 12) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3'});
                    } else if(field_count <= 15) {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b3'});
                    } else {
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2'});
                    }

                    for(var x=0; x < siteSpecific.length; x++){
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        doc.setFontSize(14);
                        doc.setFontType("bold");

                        let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        let trans_val = this.transOptions.find(x => x.key === this.inputTrans).value

                        let design_y = 20
                        let design_x = 340
                        if(field_count <= 10){
                            //follow default
                        } else if(field_count <= 12) {
                            design_x = 400
                        } else if(field_count <= 15) {
                            design_x = 490
                        } else {
                            design_x = 580
                        }
                        
                        doc.text(15,design_y,`POS ${trans_val} Report by ${group_val}`)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        design_y = design_y + 5;
                        doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                        if(x > 0){
                            //add new page
                            doc.addPage();
                        }

                        design_y = design_y + 10;
                        doc.text(15,design_y,"Site Name: " + siteSpecific[x].report_details[0].site_name)

                        this.birSalesReports = siteSpecific[x].report_details

                        let grouper = ''
                        
                        let initial_index = 3
                        let detailColStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 40},
                            2: {cellWidth: 40},
                            3: {cellWidth: 30},
                        } 
                        
                        if(this.inputGroupBy == 'session_id'){
                            detailColStyles = {
                                0: {cellWidth: 30},
                                1: {cellWidth: 40},
                                2: {cellWidth: 40}
                            } 
                            initial_index = 2
                        }
                        
                        let dynamic_header = []
                        if(this.inputGroupBy == 'terminal_id'){
                            dynamic_header = [
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Timestamp', styles: {halign: 'center'}},
                                {content: 'User', styles: {halign: 'center'}},
                                {content: 'Supervisor Code', styles: {halign: 'center'}}
                            ]
                        } else if (this.inputGroupBy == 'user_id'){
                            dynamic_header = [
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Timestamp', styles: {halign: 'center'}},
                                {content: 'Terminal', styles: {halign: 'center'}},
                                {content: 'Supervisor Code', styles: {halign: 'center'}}
                            ]
                        } else if (this.inputGroupBy == 'session_id'){
                            dynamic_header = [
                                {content: 'Business Date', styles: {halign: 'center'}},
                                {content: 'Timestamp', styles: {halign: 'center'}},
                                {content: 'Supervisor Code', styles: {halign: 'center'}}
                            ]
                        }
                        
                        // Use the report-wide union so every site's table has the SAME
                        // data columns (the widest row dictates the column count).
                        let dataKeys = allDataKeys
                        for (let key of dataKeys) {
                            initial_index = initial_index + 1

                            dynamic_header.push({content: this.formatHeader(key), styles: {halign: 'center'}})
                            detailColStyles[initial_index] = {cellWidth: 30}
                        }

                        if(this.birSalesReports.length > 0){
                            let reportData = []

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                //body
                                let detail = []
                                if(this.inputGroupBy == 'terminal_id'){
                                    detail = [
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                        {content: reportLine.cashier_name, styles: {halign: 'left'}},
                                        reportLine.supervisor_code
                                    ]
                                } else if (this.inputGroupBy == 'user_id'){
                                    detail = [
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                        reportLine.terminal_name,
                                        reportLine.supervisor_code
                                    ]
                                } else if (this.inputGroupBy == 'session_id'){
                                    detail = [
                                        {content: moment(reportLine.business_date).format('MM/DD/YYYY'), styles: {halign: 'center'}},
                                        {content: moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'), styles: {halign: 'center'}},
                                        reportLine.supervisor_code
                                    ]
                                }
                                
                                // Map each row's data values BY KEY (aligned to the union header),
                                // so every value lands under its correct column.
                                let additional_values = this.parseData(reportLine.data)
                                for (let key of dataKeys) {
                                    let val = (additional_values && additional_values[key] !== undefined) ? additional_values[key] : ''
                                    if (val === null || val === undefined){
                                        // null / missing values display as blank
                                        detail.push('')
                                    } else if (typeof val === 'object'){
                                        detail.push(JSON.stringify(val))
                                    } else {
                                        detail.push(val)
                                    }
                                    console.log(detail)
                                }

                                if(this.inputGroupBy == 'terminal_id'){
                                    if(grouper == ''){
                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                    } else {
                                        if(grouper != reportLine.terminal_id){
                                            //if new terminal display prev terminal details
                                            design_y = design_y + 5
                                            doc.autoTable({
                                                startY: design_y, 
                                                head: [dynamic_header],
                                                body: reportData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'right'
                                                },
                                                columnStyles: detailColStyles
                                            });

                                            reportData = []

                                            //add new page
                                            doc.addPage();

                                            design_y = 20;
                                            doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                        }
                                    }
                                    grouper = reportLine.terminal_id
                                } else if (this.inputGroupBy == 'user_id'){
                                    if(grouper == ''){
                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)
                                    } else {
                                        if(grouper != reportLine.user_id){
                                            //if new cashier display prev cashier details
                                            design_y = design_y + 5
                                            doc.autoTable({
                                                startY: design_y, 
                                                head: [dynamic_header],
                                                body: reportData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'right'
                                                },
                                                columnStyles: detailColStyles
                                            });

                                            reportData = []

                                            //add new page
                                            doc.addPage();

                                            design_y = 20;
                                            doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)
                                        }
                                    }
                                    grouper = reportLine.user_id
                                } else if (this.inputGroupBy == 'session_id'){
                                    if(grouper == ''){
                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Session ID: " + reportLine.session_id)

                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)

                                        design_y = design_y + 5;
                                        doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                    } else {
                                        if(grouper != reportLine.session_id){
                                            //if new session display prev session details
                                            design_y = design_y + 5
                                            doc.autoTable({
                                                startY: design_y, 
                                                head: [dynamic_header],
                                                body: reportData, 
                                                theme: 'plain',
                                                tableWidth: 'wrap',
                                                headStyles: {
                                                    lineWidth: 0.15
                                                },
                                                styles: {
                                                    cellPadding: 1.0, fontSize: 9,
                                                    halign: 'right'
                                                },
                                                columnStyles: detailColStyles
                                            });

                                            reportData = []

                                            //add new page
                                            doc.addPage();

                                            design_y = 20;
                                            doc.text(15,design_y,"Session ID: " + reportLine.session_id)

                                            design_y = design_y + 5;
                                            doc.text(15,design_y,"Cashier Name: " + reportLine.cashier_name)

                                            design_y = design_y + 5;
                                            doc.text(15,design_y,"Terminal Name: " + reportLine.terminal_name)
                                        }
                                    }
                                    grouper = reportLine.session_id
                                }

                                reportData.push(detail)

                                if(i == this.birSalesReports.length-1){
                                    design_y = design_y + 5
                                    doc.autoTable({
                                        startY: design_y, 
                                        head: [dynamic_header],
                                        body: reportData, 
                                        theme: 'plain',
                                        tableWidth: 'wrap',
                                        headStyles: {
                                            lineWidth: 0.15
                                        },
                                        styles: {
                                            cellPadding: 1.0, fontSize: 9,
                                            halign: 'right'
                                        },
                                        columnStyles: detailColStyles
                                    });
                                }
                            }
                        }
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 0; i < pageCount; i++) { 
                        doc.setPage(i);
                        doc.text(340,210,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                    }

                    // doc.save(`POS_Activity_${this.inputTrans}_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_activity_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&group=' + this.inputGroupBy + '&trans_code=' + this.inputTrans, null);

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                var siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let site_specific = [];

                    // Union of data keys across EVERY row of EVERY site, so all rows share
                    // the same data columns (the widest row dictates the column count).
                    let allDataKeys = this.collectAllDataKeys(siteSpecific)

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let dynamic_header = []
                        if(this.inputGroupBy == 'terminal_id'){
                            dynamic_header = ['Business Date','Timestamp','User','Supervisor Code']
                        } else if (this.inputGroupBy == 'user_id'){
                            dynamic_header = ['Business Date','Timestamp','Terminal','Supervisor Code']
                        } else if (this.inputGroupBy == 'session_id'){
                            dynamic_header = ['Business Date','Timestamp','Supervisor Code']
                        }
                        // Use the report-wide union so every row maps to the SAME set of
                        // data columns (the widest row dictates the column count).
                        let dataKeys = allDataKeys
                        for (let key of dataKeys) {
                            if (key.toString() == '0' || key.toString() == '1'){
                                dynamic_header.push("'"+key.toString())
                            } else {
                                dynamic_header.push(this.formatHeader(key))
                            }
                        }
                        headers = dynamic_header

                        let reportData = []
                        if(this.birSalesReports.length > 0){

                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                //body
                                let detail = []
                                if(this.inputGroupBy == 'terminal_id'){
                                    detail = [moment(reportLine.business_date).format('MM/DD/YYYY'),moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'),reportLine.cashier_name,reportLine.supervisor_code]
                                } else if (this.inputGroupBy == 'user_id'){
                                    detail = [moment(reportLine.business_date).format('MM/DD/YYYY'),moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'),reportLine.terminal_name,reportLine.supervisor_code]
                                } else if (this.inputGroupBy == 'session_id'){
                                    detail = [moment(reportLine.business_date).format('MM/DD/YYYY'), moment(reportLine.date).format('MM/DD/YYYY hh:mm:ss a'),reportLine.supervisor_code]
                                }

                                // Map each row's data values BY KEY (aligned to the union header),
                                // so every value lands under its correct column.
                                let additional_values = this.parseData(reportLine.data)
                                for (let key of dataKeys) {
                                    let val = (additional_values && additional_values[key] !== undefined) ? additional_values[key] : ''
                                    if (val === null || val === undefined){
                                        // null / missing values display as blank
                                        detail.push('')
                                    } else if (typeof val === 'object'){
                                        detail.push(JSON.stringify(val))
                                    } else {
                                        detail.push(val)
                                    }
                                }
                                reportData.push(detail)
                            }
                        }
                        
                        console.log(reportData)
                        console.log(headers)
                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }


                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                        console.log(newJsonData)
                        // this.JsonData = site_specific;
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
        }
    };
</script>

<style></style>